// ?use_ios_ui — the load stopped somewhere Retry cannot fix (iOS
// AssemblerError.isDeadEnd's Android twin): no code was given, or the
// retry budget is spent. The card then offers "Back to product page".

import { EXHAUSTED_MESSAGE, NO_INVOCATION_MESSAGE } from '@/services/wheel-loader'

export function isDeadEndLoad(state: { pollingError: string | null; downloadError: string | null }): boolean {
  const message = state.pollingError ?? state.downloadError
  return message === NO_INVOCATION_MESSAGE || message === EXHAUSTED_MESSAGE
}
